import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import {Tree} from "../../form/tree";
import {postData} from "../../../utils/request";
import isEqual from "lodash-es/isEqual";

class menuForm extends React.Component {

    state = {};

    formatTreeData = (items, from = 'items', to = 'children') => {
        return (items || []).map((item) => {
            item.key = item.id;
            if(item.items) {
                item[to] = this.formatTreeData(item[from]);
            }
            return item;
        });
    };

    onItemMove = async (event) => {
        if (!event.dragNode) {
            const ids = event.value.map((item) => item.id);
            this.props.setFieldValue("items", this.props.values.items.sort((a, b) => {
                return ids.indexOf(a.id) - ids.indexOf(b.id);
            }));
        } else {
            await postData({
                action: 'menuitem.move',
                from: (event.fromNode || {}).id || this.props.values[this.props.componentConfig.idfield],
                to: (event.dropNode || {}).id || this.props.values[this.props.componentConfig.idfield],
                id: event.dragNode.id
            });
            this.setState({items: this.formatTreeData(event.value, 'children', 'items')});
        }
    }

    componentDidUpdate() {
        if(!isEqual(this.props.values.items, this.state.items)) {
            this.setState({
                items: this.props.values.items
            });
        }
    }

    render() {
        const tree = this.formatTreeData(JSON.parse(JSON.stringify([...(this.state.items || this.props.values.items || [])])));
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-4 col-sm-pull-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="token"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Token"
                        />
                    </div>
                    <div className="col-sm-4 col-sm-pull-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="label"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            disabled="disabled"
                            label="Név"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <Tree
                            value={tree}
                            dragdropScope="menutree"
                            onDragDrop={event => this.onItemMove(event)}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(menuForm);